import {getDayToday} from '../../../utils/formatTime';

const renderCurrentOpenStatus = location => {
  if (location.open) {
    if (!location.accepting_orders || !location.is_order_ahead_enabled) {
      return 'Unable to accept orders at the moment';
    }
    return `Open ${location.ordering_hours[getDayToday()].map((time, index) =>
      index !== 0 ? ` ${time}` : time
    )}`;
  } else {
    return 'Closed';
  }
};

export default renderCurrentOpenStatus;
